import validate from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/middleware/auth.ts"),
  "redirect-if-authenticated": () => import("/Users/rayyach/Desktop/sites/saveAtCost.co/middleware/redirectIfAuthenticated.js")
}